
define('jsx!components/finn-carousel/main',['jquery', 'underscore', 'react', 'lib', 'finn-carousel'], function($, _, React, lib, FINNExternalDistribution) {
    'use strict';

    var PureRenderMixin = React.addons.PureRenderMixin;

    var FinnCarousel = React.createClass({displayName: "FinnCarousel",
        componentDidMount: function() {
            this.createCarousel();
        },

        optionsSuccess: function(fullwidth) {
            return {
                selector: fullwidth ? '#horizontalCarousel' : "#verticalCarousel",
                channel: 'e24',
                position: fullwidth ? 'netboard' : 'article',
                carouselid: 'e24',
                direction: fullwidth ? 'horizontal' : 'vertical',
                inview: false,
            };
        },

        createCarousel: function() {
            var options = {
                remote: '//www.finn.no/distribution-carousel',
                inview: false,
            };

            var carousel = new FINNExternalDistribution.Carousel(options);
            var optionsSuccess = this.optionsSuccess(this.props.fullwidth);

            carousel.inject(optionsSuccess, function(err, result) {});
        },

        render: function() {
            var carouselId = this.props.fullwidth ? 'horizontalCarousel' : 'verticalCarousel';

            return (
                React.createElement("div", null, 
                    React.createElement("div", {id: carouselId})
                )
            );
        }
    });

    return function renderComponent(element, config) {
        if (!element) {
            return;
        }
        config = config || {};
        config.fullwidth = element.getAttribute('data-fullwidth');

        React.render(React.createElement(FinnCarousel, React.__spread({},  config)), element);
    };
});

